const PredefinedIcon = {
  SAVE: 'save',
  ARCHIVE: 'archive',
  DELETE: 'delete',
  EDIT: 'edit',
  DOWNLOAD: 'download',
  UPDATE_PDF: 'updatePDF',
  SEND_TO_MY_EMAIL: 'sendToMyEmail',
  ADD_COMMENT: 'addComment',
};

module.exports = PredefinedIcon;
